









import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WSearchBox extends BaseComponent {
	@Prop({ type: String, required: true })
	what!: string;

	@Prop({ type: Number, default: 3 })
	minLength!: number;

	@Prop({ type: Number, default: 1500 })
	delay!: number;

	timeOut: any = null;
	search: string = "";

	get form() {
		return {
			fields: {
				search: {
					field: "input",
					attrs: {
						name: "search",
						type: "text",
						minlength: this.minLength
					},
					i18n: { placeholder: this.what }
				},
				button: {
					type: "button",
					i18n: "SX_LANG_SEARCH"
				}
			}
		};
	}

	@Emit("search")
	onSearch(search: string) {}

	onSearchClicked(): any {
		let search = this.search.trim();
		if (search.length >= this.minLength) {
			this.onSearch(search);
		} else {
			app.view.dialog({
				type: "error",
				text: "SX_LANG_SEARCH_INPUT_ERROR",
				data: {
					min: this.minLength
				}
			});
		}
	}

	destroy() {
		clearTimeout(this.timeOut);
	}
}
